import { createInertiaApp, router } from '@inertiajs/vue3'
import { createApp, DefineComponent, h } from 'vue'
import { initI18n } from '@/i18n'

initI18n()

// Handle hash scrolling after Inertia navigation (cross-page navigation)
router.on('navigate', () => {
  const hash = window.location.hash
  if (hash && hash !== '#') {
    // Use setTimeout to ensure DOM is ready after page render
    setTimeout(() => {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }
})

createInertiaApp({
  title: title => title ? `${title} - Paulo Vitor` : 'Paulo Vitor',
  progress: {
    delay: 500,
    color: '#f59e0b',
  },

  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>('../pages/**/*.vue', {
      eager: true,
    })
    return pages[`../pages/${name}.vue`]
  },

  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)
  },
})
